import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-spinner',
  templateUrl: './flight-spinner.component.html',
  styleUrls: ['./flight-spinner.component.scss']
})
export class FlightSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
